import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { AppConstants, SERVER, LOGON_INFO, COMP_TYPE, SHARE_FLAG } from "../app.constants";
import { CommonService } from "../app.service";


@Injectable()
export class CaseService {

    logon_user_id: string;
    logon_comp_id: string;
    logon_comp_type: string;
    logon_parent_comp_id: string;

    constructor(
        private _htc: HttpClient
    ) {
        this.logon_user_id = LOGON_INFO.USER_ID;
        this.logon_comp_id = LOGON_INFO.COMP_ID;
        this.logon_comp_type = LOGON_INFO.COMP_TYPE;
        this.logon_parent_comp_id = LOGON_INFO.PARENT_COMP_ID;
    }

    //案件リストを取得
    getCaseList(div: string, page: number, search_comp_id, search_status: string, search_date_start: any, search_date_end: any): Observable<Case[]> {    
        let params = new HttpParams().set('page', page.toString())
                                    .append('user_id', this.logon_user_id)
                                    .append('search_comp_id', search_comp_id)
                                    .append('search_status', search_status)
                                    .append('search_date_start', search_date_start ? search_date_start.formatted : "")
                                    .append('search_date_end', search_date_end ? search_date_end.formatted : "");
        return this._htc.get<Case[]>(SERVER.baseURL+'/case-list/'+div+'/'+this.logon_comp_id+'/', {params: params});
    }

    //案件登録
    registCase(c: Case) {
        this.setParam(c);
        c.id = undefined;

        //案件登録者が荷主　かつ　グループ関係がある(親会社がある)場合
        if (this.logon_comp_type == COMP_TYPE.CLIENT && this.logon_comp_id != this.logon_parent_comp_id) {
            c.share_comp_id = this.logon_parent_comp_id;
        }
        //貨物登録者が運送会社の場合
        else if (this.logon_comp_type != COMP_TYPE.CLIENT) {
            c.share_comp_id = this.logon_comp_id;
        }
        
        return this._htc.post<Case>(SERVER.baseURL+'/case-regist/', JSON.stringify(c));
    }

    //案件更新
    updateCase(c: Case) {
        this.setParam(c);
        return this._htc.put<Case>(SERVER.baseURL+'/case-update/'+c.id+'/', JSON.stringify(c));
    }

    //案件重要度変更
    updateCaseImportance(id: number, importance: string) {
        return this._htc.put<Case>(SERVER.baseURL+'/case-importance-update/'+id+'/', JSON.stringify({importance:importance}));
    }

    //案件status更新
    updateCaseStatus(id: number, status: string) {
        return this._htc.put<Case>(SERVER.baseURL+'/case-status-update/'+id+'/', JSON.stringify({status:status, update_id:this.logon_user_id}));
    }

    //案件削除（論理削除）
    deleteCargo(id: number) {
        return this._htc.put<Case>(SERVER.baseURL+'/case-delete/'+id+'/', JSON.stringify({update_id:this.logon_user_id}));
    }

    //車両配車登録
    registMatchCar(case_id: number, match_car_list: Object[], require_car_num: number) {
        let param = {
            case_id: case_id,
            match_car_list: match_car_list,
            update_id: this.logon_user_id,
            require_car_num: require_car_num
        };
        return this._htc.put(SERVER.baseURL+'/case-match-car/', JSON.stringify(param));
    }

    //車両運送スケジュール取得
    getCarScheduleList(case_id: number, start_ymd: string, end_ymd: string) {            
        return this._htc.get(SERVER.baseURL+'/car-schedule-list/' + case_id + '/' + start_ymd + '/' + end_ymd).toPromise();
    }

    //共有情報更新
    updateShareInfo(c: Case): Observable<Case> {
        let param = {
            share_flag: c.share_flag,
            share_comp_id: c.share_comp_id,
            share_flag_2: c.share_flag_2,
            share_comp_id_2: c.share_comp_id_2,
            update_id: this.logon_user_id
        };
        return this._htc.put<Case>(SERVER.baseURL+'/case-share-update/'+c.id+'/', JSON.stringify(param));
    }

    private setParam(c: Case) {
        c.create_id = this.logon_user_id;
        c.update_id = this.logon_user_id;
        c.start_date = c.start_date.formatted.split('/').join('-') + " " + c.start_time + ":00:00";
        c.end_date = c.end_date.formatted.split('/').join('-') + " " + c.end_time + ":00:00";
        c.trans_comp_id = this.logon_comp_id;

        c.importance = undefined;
        c.new_flag = undefined;
        c.status_name = undefined;
        c.importance_name = undefined;
        c.client_comp_name = undefined;
        c.trans_comp_name = undefined;
        c.share_flag = undefined;
        c.share_comp_id = undefined;
        c.share_flag_2 = undefined;
        c.share_comp_id_2 = undefined;
        c.share_comp_name = undefined;
        c.is_active = undefined;
        c.create_date = undefined;
        c.update_date = undefined;
    }


    




    ////////// autoRefresh用　START ///////////////////////////////////////////////////
    isAccessibleCase(c: Case): boolean {
        if (c.share_flag == SHARE_FLAG.ALL
            || (c.share_flag == SHARE_FLAG.COMPANY && c.share_comp_id == LOGON_INFO.COMP_ID)
            || c.share_flag_2 == SHARE_FLAG.ALL
            || (c.share_flag_2 == SHARE_FLAG.COMPANY && c.share_comp_id_2 == LOGON_INFO.COMP_ID)
            || (c.share_flag_2 == SHARE_FLAG.BRANCH && LOGON_INFO.COMP_TYPE == COMP_TYPE.BRANCH && c.share_comp_id_2 == LOGON_INFO.PARENT_COMP_ID)
            || (c.share_flag_2 == SHARE_FLAG.PARTNER && LOGON_INFO.COMP_TYPE == COMP_TYPE.PARTNER && c.share_comp_id_2 == LOGON_INFO.PARENT_COMP_ID)) {
                return true;
        }
        return false;
    }

    addCaseToList(caseList: Case[], c: Case): boolean {
        if (!caseList || !caseList.length) {
            caseList.push(c);
        } else {
            caseList.unshift(c);
            caseList.sort(function(a,b) {
                return b.id - a.id;
            });
            if (caseList.length > AppConstants.PAGE_SIZE_LARGE) {
                caseList.pop();
            }
        }
        
        return true;
    }

    deleteCaseFromList(caseList: Case[], c: Case): boolean {
        let idx = caseList.findIndex(({id}) => id === c.id);
        if (idx > -1) {
            caseList.splice(idx, 1);
            return true;
        }
        return false;
    }

    replaceCaseFromList(caseList: Case[], c: Case): boolean {
        let idx = caseList.findIndex(({id}) => id === c.id);
        if (idx > -1) {
            caseList.splice(idx, 1, c);
            return true;
        }
        return false;
    }
    ////////// autoRefresh用　END ///////////////////////////////////////////////////
}





export class Case {
    id: number;
    status: string;
    status_name: string;
    new_flag: string;
    importance: string;
    importance_name: string;
    trans_comp_id: string;
    trans_comp_name: string;
    client_comp_id: string;
    client_comp_name: string;
    customer_1: string;
    customer_2: string;
    customer_3: string;
    start_date: any;
    start_time: string;
    end_date: any;
    end_time: string;
    work_date_name: string;
    work_place: string;
    distance: number;
    cargo_item: string;
    car_ability: string;
    car_ability_name: string;
    day_night: string;
    cargo_quantity: number;
    cargo_unit: string;
    cargo_unit_name: string;
    require_car_num: string;
    require_car_num_viewlist: RequireCarNum[];
    etc: string | undefined;
    share_flag: string;
    share_comp_id: string;
    share_flag_2: string;
    share_comp_id_2: string;
    share_comp_name: string;
    is_active: string;
    create_id: string;
    create_date: Date;
    update_id: string;
    update_date: Date;
    tooltip: string;
}

export class RequireCarNum {
    timestamp: number;
    date_str: string;
    require_car_num: number;
    weekday: string;
}




// WEBPACK FOOTER //
// ./src/app/case/case.service.ts